import type { ActivityModule } from '../../core/activity';
import { runVerticalActivity, filterLaidLevels } from '../../shared/vertical-runner';
import levelsData from './levels.json';
import './style.css';

const LEVELS = filterLaidLevels(levelsData.levels);

export const verticalSubtraction: ActivityModule = {
  id: 'vertical_subtraction',
  title: 'Subtração em coluna',
  description: 'Resolva contas de subtração armadas em coluna (2 a 4 dígitos, com e sem empréstimo).',
  ageMin: 7,
  ageMax: 11,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/vertical_subtraction/icon.svg',
  category: 'aritmetica',
  totalLevels: LEVELS.length,
  mount: (ctx) => runVerticalActivity(ctx, {
    operation: 'minus',
    title: 'Subtração em coluna',
    activityId: 'vertical_subtraction',
    levels: LEVELS,
  }),
};
